import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/* ═══════════════════════════════════════════════════
   Tutorial SESAAT — pusat belajar dalam-app

   SUMBER SEBENAR = Firestore `config/tutorial` (admin edit terus di halaman,
   corak SAMA macam `config/changelog`). SEED di bawah = salinan simpanan:
   dipakai kalau doc belum wujud ATAU bacaan Firestore gagal — halaman tetap
   ada isi, bukan kosong.

   ── KENAPA VIDEO DUDUK DI YOUTUBE ──
   Kita simpan `youtubeId` sahaja, bukan file video. Thumbnail pun diambil
   percuma dari YouTube (img.youtube.com), jadi halaman ini TIDAK menambah
   sebarang kos Firebase Storage mahupun egress.

   ── GAYA AYAT (arahan user 2026-07-28) ──
   Formal Melayu tetapi MUDAH FAHAM, bukan gaya buku teks. Terma teknikal KEKAL
   English: run, generate, scrape, extension, browser, scene, video, card, set,
   prompt, tag, collection, Cloud, storage, download, install.
   ═══════════════════════════════════════════════════ */

export const TUTORIAL_DOC = 'tutorial';            // config/tutorial
const SESSION_CACHE_KEY = 'sesaat_tutorial_cache';
const WATCHED_KEY = 'sesaat_tutorial_watched';

export const PLAYLIST_URL = 'https://www.youtube.com/playlist?list=PLUgKht1i8s1Yo9oEW_L4yUE4o_NWx1oIX';
export const WHATSAPP_GROUP_URL = 'https://chat.whatsapp.com/EgRsfEpex1L7S2KPbiToDa';

export const SEED = {
    subtitle: 'Dari install extension sampai video naik TikTok — semua panduan dalam satu tempat.',
    // Video di bawah sengaja dibiar tanpa `youtubeId`. Admin tampal link YouTube
    // sendiri melalui butang "✎ Edit halaman" — tiada deploy diperlukan.
    categories: [
        { id: 'mula', label: 'Mula' },
        { id: 'import', label: 'Import' },
        { id: 'generate', label: 'Generate' },
        { id: 'flow', label: 'Run Flow' },
        { id: 'tiktok', label: 'TikTok' },
    ],
    /* Lima langkah — tulang belakang perjalanan sebenar, dari install
       sehingga video naik TikTok. Sengaja BUKAN senarai semua video:
       langkah yang boleh dilangkau (login panel, pilih module, urus
       storage, schedule) tinggal dalam babnya sendiri. Timeline ini
       menjawab satu soalan sahaja — "lepas ni apa?" */
    startHere: ['v_install', 'v_import', 'v_generate', 'v_runflow', 'v_runtiktok'],
    videos: [
        {
            id: 'v_install',
            category: 'mula',
            title: 'Cara install Extension SESAAT',
            body: 'Download file ZIP di Dashboard, unzip, kemudian load dalam Chrome. Selepas ini side panel SESAAT terus sedia digunakan.',
            youtubeId: '',
            duration: '',
            isNew: false,
            ctaLabel: 'Buka halaman Extension',
            ctaHref: '/extension',
        },
        {
            id: 'v_panel',
            category: 'mula',
            title: 'Login dan kenali side panel',
            body: 'Log masuk akaun anda di extension, dan kenali fungsi setiap butang dalam panel: SAVE, IMPORT dan tetapan.',
            youtubeId: '',
            duration: '',
            isNew: false,
        },
        {
            id: 'v_tour',
            category: 'mula',
            title: 'Tour webapp: Dashboard hingga Workspace',
            body: 'Gambaran besar sistem — di mana Products disimpan, di mana anda generate, dan maksud tab Flow serta TikTok.',
            youtubeId: '',
            duration: '',
            isNew: false,
        },
        {
            id: 'v_import',
            category: 'import',
            title: 'Import Products dari TikTok Shop',
            body: 'Tampal link produk atau naikkan file Excel, kemudian biarkan sistem scrape data produk sehingga status bertukar READY.',
            youtubeId: '',
            duration: '',
            isNew: false,
        },
        {
            id: 'v_pending',
            category: 'import',
            title: 'Option 3 — lengkapkan product PENDING',
            body: 'Card dalam My Products yang bertanda PENDING boleh di-scrape sekali gus. Card asal terus dikemas kini di tempatnya, tanpa card berganda.',
            youtubeId: '',
            duration: '',
            isNew: true,
        },
        {
            id: 'v_generate',
            category: 'generate',
            title: 'Generate content — satu klik, tiga set',
            body: 'Pilih product yang READY dan tekan Generate. Satu generation menghasilkan tiga set lengkap: prompt image, prompt video dan caption.',
            youtubeId: '',
            duration: '',
            isNew: false,
        },
        {
            id: 'v_module',
            category: 'generate',
            title: 'Pilih module yang sesuai dengan product',
            body: 'Bila guna AI8SAAT, GOYANG, AI16SAAT atau Home Niche — beserta contoh jenis product yang paling sesuai untuk setiap module.',
            youtubeId: '',
            duration: '',
            isNew: false,
        },
        {
            id: 'v_runflow',
            category: 'flow',
            title: 'Run Flow — video dijana automatik',
            body: 'Tandakan card dan tekan Run Flow. Sistem akan upload image, tampal prompt, dan memantau sehingga video siap dijana.',
            youtubeId: '',
            duration: '',
            isNew: false,
        },
        {
            id: 'v_duplicate',
            category: 'flow',
            title: 'Duplicate card — stok pipeline yang menjadi',
            body: 'Sudah jumpa pipeline yang menjadi? Salin card tersebut dan run serentak untuk kumpul stok video daripada hook dan prompt yang sama.',
            youtubeId: '',
            duration: '',
            isNew: true,
        },
        {
            id: 'v_storage',
            category: 'flow',
            title: 'Save video dan urus storage 5 GB',
            body: 'Bila video disimpan dalam browser dan bila ia naik ke Cloud, serta cara menggunakan butang Optimize apabila storage hampir penuh.',
            youtubeId: '',
            duration: '',
            isNew: false,
        },
        {
            id: 'v_runtiktok',
            category: 'tiktok',
            title: 'Run TikTok — upload video automatik',
            body: 'Tandakan card sebagai TikTok dan tekan Run. Video berserta caption akan dinaikkan ke TikTok Studio secara automatik.',
            youtubeId: '',
            duration: '',
            isNew: false,
        },
        {
            id: 'v_schedule',
            category: 'tiktok',
            title: 'Schedule dan slot posting harian',
            body: 'Tetapkan template jadual dan bilangan slot sehari supaya posting kekal konsisten tanpa perlu dijaga sepanjang hari.',
            youtubeId: '',
            duration: '',
            isNew: false,
        },
    ],
};

/* ═══════════════════════════════════════════════════════════════
   ARTIKEL BERGAMBAR — blok kandungan lesson
   ═══════════════════════════════════════════════════════════════
   Satu lesson boleh membawa senarai `blocks`. Admin menyusunnya
   sendiri di halaman lesson (butang "Edit artikel") dan menekan
   Simpan — kandungan disimpan dalam doc `config/tutorial` yang SAMA,
   jadi tiada deploy diperlukan untuk menukar sebarang teks, gambar
   atau susunan.

   ⛔ SETIAP BLOK WAJIB TAHAN DATA ROSAK. Doc ini disunting oleh
      manusia dan dibaca oleh pelanggan; satu medan hilang tidak boleh
      menghempaskan halaman. `normalizeBlok` memulangkan null untuk
      blok yang tidak dikenali, dan pemanggil menapisnya keluar.

   ⭐ SENARAI KANDUNGAN dijana SENDIRI daripada blok `tajuk` — admin
      tidak perlu menyelenggara dua senarai yang boleh terpesong.
   ═══════════════════════════════════════════════════════════════ */

export const JENIS_BLOK = [
    { jenis: 'tajuk', nama: 'Tajuk seksyen', nota: 'Masuk senarai kandungan automatik' },
    { jenis: 'teks', nama: 'Perenggan', nota: 'Link jadi pautan hidup sendiri' },
    { jenis: 'langkah', nama: 'Langkah bernombor', nota: 'Satu baris satu langkah' },
    { jenis: 'semak', nama: 'Senarai bertanda', nota: 'Untuk syarat / hasil akhir' },
    { jenis: 'gambar', nama: 'Gambar', nota: 'Muat naik terus, auto-mampat' },
    { jenis: 'nota', nama: 'Kotak nota', nota: 'Tip · hati-hati · jangan buat' },
    { jenis: 'jadual', nama: 'Jadual', nota: 'Dua lajur' },
    { jenis: 'sj', nama: 'Soal jawab', nota: 'Boleh buka-tutup' },
];

const JENIS_SAH = new Set(JENIS_BLOK.map(b => b.jenis));
const GAYA_NOTA_SAH = new Set(['tip', 'info', 'amaran', 'stop']);
const teksSelamat = (x) => (typeof x === 'string' ? x : '');
const senaraiTeks = (x) => (Array.isArray(x) ? x.map(teksSelamat) : []);

function normalizeBlok(b, i) {
    if (!b || typeof b !== 'object' || !JENIS_SAH.has(b.jenis)) return null;
    const asas = { id: teksSelamat(b.id) || `b_${i}`, jenis: b.jenis };
    switch (b.jenis) {
        case 'tajuk':
        case 'teks':
            return { ...asas, teks: teksSelamat(b.teks) };
        case 'langkah':
        case 'semak':
            return { ...asas, tajuk: teksSelamat(b.tajuk), items: senaraiTeks(b.items) };
        case 'gambar':
            return {
                ...asas,
                url: teksSelamat(b.url),
                path: teksSelamat(b.path),
                kapsyen: teksSelamat(b.kapsyen),
            };
        case 'nota':
            return {
                ...asas,
                gaya: GAYA_NOTA_SAH.has(b.gaya) ? b.gaya : 'tip',
                tajuk: teksSelamat(b.tajuk),
                teks: teksSelamat(b.teks),
            };
        case 'jadual':
            return {
                ...asas,
                kepala: senaraiTeks(b.kepala).slice(0, 2),
                /* Setiap baris dipaksa tepat 2 sel — baris pendek/panjang
                   daripada suntingan lama akan merosakkan jadual HTML. */
                baris: (Array.isArray(b.baris) ? b.baris : []).map(r => {
                    const sel = senaraiTeks(r);
                    return [sel[0] || '', sel[1] || ''];
                }),
            };
        case 'sj':
            return {
                ...asas,
                items: (Array.isArray(b.items) ? b.items : []).map(x => ({
                    s: teksSelamat(x?.s),
                    j: teksSelamat(x?.j),
                })),
            };
        default:
            return null;
    }
}

/* Id sauh untuk pautan senarai kandungan. Dikira daripada KEDUDUKAN,
   bukan daripada teks tajuk: tajuk boleh disunting bila-bila masa, dan
   sauh yang berubah akan mematikan pautan yang sudah dikongsi. */
export const idTajukBlok = (blok, i) => `sek-${blok.id || i}`;

/* Anggaran masa baca — 200 patah perkataan seminit, dibundarkan ke atas.
   Dikira daripada kandungan sebenar supaya admin tidak perlu
   menyelenggara nombor yang pasti akan basi. */
export function kiraMasaBaca(lesson) {
    if (!lesson) return 1;
    const kepingan = [lesson.body || ''];
    for (const b of lesson.blocks || []) {
        if (b.teks) kepingan.push(b.teks);
        if (b.tajuk) kepingan.push(b.tajuk);
        if (Array.isArray(b.items)) {
            for (const it of b.items) kepingan.push(typeof it === 'string' ? it : `${it?.s || ''} ${it?.j || ''}`);
        }
        if (Array.isArray(b.baris)) for (const r of b.baris) kepingan.push(r.join(' '));
        if (b.kapsyen) kepingan.push(b.kapsyen);
    }
    const patah = kepingan.join(' ').trim().split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.ceil(patah / 200));
}

// ─── Bentuk data: pastikan setiap medan wujud walau doc lama tak lengkap ───
export function normalizeTutorial(raw) {
    const src = raw && Array.isArray(raw.videos) ? raw : SEED;
    const categories = (src.categories?.length ? src.categories : SEED.categories).map((c, i) => ({
        id: c.id || `c_${i}`,
        label: c.label || '',
    }));
    const videos = (src.videos || []).map((v, i) => ({
        id: v.id || `v_${i}`,
        category: v.category || categories[0]?.id || '',
        title: v.title || '',
        body: v.body || '',
        youtubeId: parseYouTubeId(v.youtubeId),
        duration: v.duration || '',
        isNew: v.isNew === true,
        /* Butang tindakan pilihan di bawah nota lesson. Wujud supaya
           lesson boleh terus menghantar pelanggan ke tempat kerja yang
           baru diterangkan — cth lesson "Install Extension" membawanya
           ke halaman Extension, tanpa dia perlu mencari menu sendiri.
           Kosong = tiada butang. */
        ctaLabel: v.ctaLabel || '',
        ctaHref: v.ctaHref || '',
        /* ⭐ ARTIKEL BERGAMBAR (2026-09-06). Senarai blok kandungan yang
           admin susun sendiri di halaman lesson — tiada deploy diperlukan.
           KOSONG = lesson kekal rupa LAMA (video + satu blok teks), jadi
           setiap lesson sedia ada tidak berubah walau satu piksel. */
        blocks: Array.isArray(v.blocks) ? v.blocks.map(normalizeBlok).filter(Boolean) : [],
    }));
    const ids = new Set(videos.map(v => v.id));
    return {
        subtitle: typeof src.subtitle === 'string' ? src.subtitle : SEED.subtitle,
        playlistUrl: typeof src.playlistUrl === 'string' ? src.playlistUrl : PLAYLIST_URL,
        whatsappUrl: typeof src.whatsappUrl === 'string' ? src.whatsappUrl : WHATSAPP_GROUP_URL,
        categories,
        // Buang rujukan kepada video yang sudah dipadam — kalau tidak, langkah
        // "Mula Sini" akan tinggal kosong tanpa sebab yang jelas kepada admin.
        startHere: (src.startHere || []).filter(id => ids.has(id)),
        videos,
    };
}

/* ─── Kurikulum: kategori → BAB, video → LESSON ────────────────────
   Satu takrifan sahaja, dipakai oleh KEDUA-DUA halaman overview
   (/tutorial) dan halaman lesson (/tutorial/:videoId). Kalau susunan
   ini disalin ke salah satu halaman, nombor "lesson 3 daripada 12"
   dan butang "Lesson seterusnya" akan terpesong antara dua halaman —
   pelanggan nampak turutan yang berlainan pada skrin yang berlainan.

   onlyPlayable — buang video tanpa link YouTube. Pelanggan tidak
     sepatutnya melihat lesson yang tidak boleh dimainkan; admin perlu
     melihatnya supaya boleh isi link tersebut. */
export function buildChapters(data, { onlyPlayable = false } = {}) {
    const videos = (data?.videos || []).filter(v => !onlyPlayable || v.youtubeId);
    const kategori = data?.categories || [];
    const bab = kategori.map(c => ({
        id: c.id,
        label: c.label || 'Tanpa nama',
        videos: videos.filter(v => v.category === c.id),
    }));

    // Video yang kategorinya sudah dipadam tidak boleh lenyap begitu sahaja —
    // ia dikumpul di hujung supaya admin nampak dan boleh betulkan.
    const dikenali = new Set(kategori.map(c => c.id));
    const yatim = videos.filter(v => !dikenali.has(v.category));
    if (yatim.length) bab.push({ id: '_lain', label: 'Lain-lain', videos: yatim });

    return bab.filter(b => b.videos.length > 0);
}

/* Turutan lesson yang sebenar: bab demi bab, mengikut susunan admin.
   Ini yang menentukan makna "seterusnya" dan "sebelumnya". */
export const flattenChapters = (chapters) => chapters.flatMap(b => b.videos);

/* ─── ALAMAT LESSON ────────────────────────────────────────────────
   Bentuk: /tutorial/<nama-chapter>-<kod>      cth /tutorial/tiktok-k3n8q

   Keputusan user 2026-08-23:
   · DEPAN = nama chapter, supaya alamat boleh dibaca sebelum diklik.
   · BELAKANG = kod pendek rawak (nombor campur abjad) yang KEKAL. Ia
     sengaja TIDAK terikat kepada apa-apa logik lain, jadi menukar tajuk
     lesson atau menyusun semula dengan ▲▼ langsung tidak menyentuhnya.
   · Lesson berpindah chapter → bahagian DEPAN bertukar dan link lama
     DIBIARKAN MATI. Keputusan user: alamat yang menyebut chapter yang
     salah tidak sepatutnya terus hidup.

   ⛔ JANGAN tukar kod ini kepada nombor berjalan (chapter-1, chapter-2).
      Halaman Overview ada butang ▲▼ untuk menyusun semula lesson, jadi
      nombor kedudukan akan beranjak — dan link lama TIDAK akan mati, ia
      akan membuka LESSON YANG SALAH. Itu lebih buruk daripada link mati,
      kerana orang menonton habis tanpa tahu dia salah tempat.

   ⭐ Kod DIKIRA daripada `id` lesson, bukan disimpan. `id` memang kekal
      seumur hidup lesson (ia juga kunci "sudah ditonton"), jadi kod ini
      kekal juga — tanpa medan baharu, tanpa migrasi data. */

export const slugTeks = (teks) => String(teks || '')
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
    .replace(/-+$/g, '');

/* Hash kecil yang stabil (FNV-1a 32-bit) → 5 aksara base36 (0-9a-z).
   Deterministik: id yang sama sentiasa memberi kod yang sama, pada
   mana-mana browser dan selepas apa jua muat semula. */
const hash36 = (teks) => {
    let h = 0x811c9dc5;
    for (let i = 0; i < teks.length; i++) {
        h ^= teks.charCodeAt(i);
        h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h.toString(36).padStart(5, '0').slice(-5);
};

/* Peta id → kod bagi satu set lesson.
   ⚠️ Perlanggaran diselesaikan mengikut turutan id yang DIISIH, bukan
      turutan paparan. Kalau ikut turutan paparan, menyusun semula lesson
      boleh menukar kod seseorang dan itu memutuskan link yang sudah
      dikongsi — tepat perkara yang reka bentuk ini cuba elakkan. */
/* ⚠️ HAD YANG DITERIMA SECARA SEDAR: kod ialah 5 aksara base36 (~60 juta
   kemungkinan). Dua lesson berlanggar hanya jika hash keduanya sama — dengan
   belasan lesson, peluangnya sekitar satu dalam sejuta. Kalau ia BENAR-BENAR
   berlaku, lesson yang idnya lebih besar akan berubah kod dan link lamanya
   pecah. Untuk menghapuskannya sepenuhnya, kod terpaksa DISIMPAN pada setiap
   lesson (medan baharu + isian sekali) — sengaja tidak dibuat kerana harganya
   lebih tinggi daripada risikonya. Kalau lesson menjangkau ratusan suatu hari
   nanti, naikkan kod kepada 6-7 aksara SEBELUM itu berlaku, bukan selepas. */
export function petaKodLesson(videos) {
    const peta = new Map();
    const diguna = new Set();
    [...(videos || [])]
        .sort((a, b) => String(a.id).localeCompare(String(b.id)))
        .forEach((v) => {
            let kod = hash36(String(v.id));
            let n = 0;
            while (diguna.has(kod)) kod = hash36(`${v.id}#${++n}`);
            diguna.add(kod);
            peta.set(v.id, kod);
        });
    return peta;
}

const slugBab = (video, data) => {
    const kategori = (data?.categories || []).find((c) => c.id === video?.category);
    return slugTeks(kategori?.label) || slugTeks(kategori?.id) || 'lain';
};

/* SATU takrifan alamat — dipakai oleh rel, halaman Overview dan butang
   "Lesson seterusnya", supaya ketiga-tiganya mustahil terpesong. */
export function alamatLesson(video, data, peta) {
    if (!video) return '/tutorial';
    const kod = (peta || petaKodLesson(data?.videos)).get(video.id);
    if (!kod) return `/tutorial/${video.id}`;
    return `/tutorial/${slugBab(video, data)}-${kod}`;
}

/* Terjemah balik alamat → lesson.
   1) Padanan terus dengan `id` — inilah yang mengekalkan SEMUA link lama
      (/tutorial/v_schedule) hidup selamanya.
   2) Bentuk baharu: pecah pada sengkang TERAKHIR, kerana nama chapter
      sendiri boleh mengandungi sengkang (cth "run-flow"). Kod mesti padan
      DAN chapter mesti padan; chapter tidak padan = tidak dijumpai. */
export function cariLessonDariAlamat(param, data) {
    const p = String(param || '');
    const videos = data?.videos || [];
    const terus = videos.find((v) => v.id === p);
    if (terus) return terus;

    const potong = p.lastIndexOf('-');
    if (potong <= 0) return null;
    const depan = p.slice(0, potong);
    const kod = p.slice(potong + 1);
    const peta = petaKodLesson(videos);
    const calon = videos.find((v) => peta.get(v.id) === kod);
    if (!calon) return null;
    return slugBab(calon, data) === depan ? calon : null;
}

// ─── YouTube ──────────────────────────────────────────
// Admin newbie akan tampal link penuh, bukan ID. Terima semua bentuk biasa.
export function parseYouTubeId(input) {
    const raw = String(input || '').trim();
    if (!raw) return '';
    const patterns = [
        /(?:youtube\.com\/watch\?(?:.*&)?v=)([A-Za-z0-9_-]{11})/,
        /(?:youtu\.be\/)([A-Za-z0-9_-]{11})/,
        /(?:youtube\.com\/(?:embed|shorts|live)\/)([A-Za-z0-9_-]{11})/,
    ];
    for (const re of patterns) {
        const m = raw.match(re);
        if (m) return m[1];
    }
    return /^[A-Za-z0-9_-]{11}$/.test(raw) ? raw : '';
}

export const youtubeThumb = (id) => (id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : '');
// youtube-nocookie = tiada cookie penjejak dipasang sehingga video benar-benar dimainkan.
export const youtubeEmbed = (id) => `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;

// ─── Bacaan ───────────────────────────────────────────
export async function loadTutorial() {
    const snap = await getDoc(doc(db, 'config', TUTORIAL_DOC));
    const data = normalizeTutorial(snap.exists() ? snap.data() : null);
    try { sessionStorage.setItem(SESSION_CACHE_KEY, JSON.stringify(data)); } catch { /* abaikan */ }
    return { data, exists: snap.exists() };
}

export async function loadTutorialCached() {
    try {
        const cached = sessionStorage.getItem(SESSION_CACHE_KEY);
        if (cached) return normalizeTutorial(JSON.parse(cached));
    } catch { /* cache rosak — baca segar */ }
    try {
        const { data } = await loadTutorial();
        return data;
    } catch {
        return normalizeTutorial(null);   // fail-safe: papar SEED
    }
}

export function clearTutorialCache() {
    try { sessionStorage.removeItem(SESSION_CACHE_KEY); } catch { /* abaikan */ }
}

// ─── Progress "sudah ditonton" ────────────────────────
// Disimpan dalam localStorage — zero kos Firestore. Per-browser: user yang guna
// 3-5 browser akan lihat progress berasingan pada setiap browser, dan itu
// memang wajar kerana setiap browser perlu install extension sendiri.

export function getWatched() {
    try {
        const raw = localStorage.getItem(WATCHED_KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return new Set(Array.isArray(arr) ? arr : []);
    } catch {
        return new Set();
    }
}

export function markWatched(id) {
    if (!id) return getWatched();
    const set = getWatched();
    set.add(id);
    try { localStorage.setItem(WATCHED_KEY, JSON.stringify([...set])); } catch { /* abaikan */ }
    return set;
}

export function unmarkWatched(id) {
    const set = getWatched();
    set.delete(id);
    try { localStorage.setItem(WATCHED_KEY, JSON.stringify([...set])); } catch { /* abaikan */ }
    return set;
}

// ─── Kilang objek baharu (dipakai butang "＋ Tambah") ───
const uid = (p) => `${p}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

export const newVideo = (categoryId = '') => ({
    id: uid('v'),
    category: categoryId,
    title: '',
    body: '',
    youtubeId: '',
    duration: '',
    isNew: true,
    ctaLabel: '',
    ctaHref: '',
    blocks: [],
});

export const newCategory = () => ({ id: uid('c'), label: '' });

/* Blok baharu lahir dengan SATU baris kosong (bukan senarai kosong) —
   senarai kosong memberi admin kotak yang langsung tiada tempat menaip
   dan dibaca sebagai butang rosak. */
export function newBlok(jenis) {
    const id = uid('b');
    switch (jenis) {
        case 'tajuk': return { id, jenis, teks: '' };
        case 'teks': return { id, jenis, teks: '' };
        case 'langkah': return { id, jenis, tajuk: '', items: [''] };
        case 'semak': return { id, jenis, tajuk: '', items: [''] };
        case 'gambar': return { id, jenis, url: '', path: '', kapsyen: '' };
        case 'nota': return { id, jenis, gaya: 'tip', tajuk: '', teks: '' };
        case 'jadual': return { id, jenis, kepala: ['', ''], baris: [['', '']] };
        case 'sj': return { id, jenis, items: [{ s: '', j: '' }] };
        default: return null;
    }
}
